
import GS1IntegrationService from "../../../../../../../server/com/silkplm/rpc/plm/services/integrations/GS1IntegrationService.js";
import NewBlackIntegrationService from "../../../../../../../server/com/silkplm/rpc/plm/services/integrations/NewBlackIntegrationService.js";
import PrestaShopIntegrationService from "../../../../../../../server/com/silkplm/rpc/plm/services/integrations/PrestaShopIntegrationService.js";
import SubiektIntegrationService from "../../../../../../../server/com/silkplm/rpc/plm/services/integrations/SubiektIntegrationService.js";

class Integrations{
    constructor() {

            /** @type {module:src/server/com/silkplm/rpc/plm/services/integrations/GS1IntegrationService.GS1IntegrationService} */
            this.GS1IntegrationService = new GS1IntegrationService();
            /** @type {module:src/server/com/silkplm/rpc/plm/services/integrations/NewBlackIntegrationService.NewBlackIntegrationService} */
            this.NewBlackIntegrationService = new NewBlackIntegrationService();
            /** @type {module:src/server/com/silkplm/rpc/plm/services/integrations/PrestaShopIntegrationService.PrestaShopIntegrationService} */
            this.PrestaShopIntegrationService = new PrestaShopIntegrationService();
            /** @type {module:src/server/com/silkplm/rpc/plm/services/integrations/SubiektIntegrationService.SubiektIntegrationService} */
            this.SubiektIntegrationService = new SubiektIntegrationService();
    }
}

export default Integrations;

